<template>
  <a v-bind="$attrs" target="_blank" rel="noreferrer"><slot /></a>
</template>
